

















































































import { Component, Prop, Vue } from "@/shared/vuepack";

import { DrivewealthAccountManagementType, DrivewealthWizardStep } from "@/shared/types";
import LoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import WizardProgress from "@/employee/components/investments/drivewealth/wizard/WizardProgress.vue";
import * as RouteNames from "@/employee/route-names";
import InstrumentName from "./InstrumentName.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import { useDrivewealthInvestmentStrategy } from "@/shared/store/drivewealthInvestmentStrategy";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useRiskToleranceQuestionnaireStore } from "@/shared/store/riskToleranceQuestionnaire";

@Component({
  components: {
    LoadingSpinner,
    InstrumentName,
    WizardProgress,
  }
})
export default class ManagedAccountConfirmPortfolio extends Vue {
  isSubmitting = false;
  notifierStore = useNotifierStore();

  investmentStrategyStore = useDrivewealthInvestmentStrategy();

  drivewealthWizardStore = useDrivewealthWizardStore();
  drivewealthStore = useDrivewealthStore();
  custodianSettingsStore = useCustodianSettingsStore();
  riskToleranceQuestionnaireStore = useRiskToleranceQuestionnaireStore();

  @Prop({ required: true })
  isWizard: boolean;

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  @Prop({ required: false })
  accountId: number;

  @Prop({ required: false })
  currentPortfolioId: string;

  @Prop({required: false})
  isPreenrollment: boolean;

  @Prop({required: false})
  isCreatingAccount: boolean;

  @Prop({required: false})
  isSavingAccountClaims: boolean;

  mounted (): void {
    this.drivewealthWizardStore.loadDividendReinvestmentDisclosures({});
  }

  get step () {
    return DrivewealthWizardStep.PortfolioConfirmation;
  }

  onReAnswer () {
    this.$emit("shouldRetreat");

    if (this.isWizard) {
      this.drivewealthWizardStore.forceStepIncomplete(DrivewealthWizardStep.PortfolioSelection);
    }
  }

  onCancel () {
    if (this.isWizard) {
      this.$router.push(
        { name: RouteNames.DrivewealthWizard, params: { step: DrivewealthWizardStep.SelectAccountType } });
    } else {
      this.$router.push({ name: RouteNames.InvestmentAccountInfo });
    }
  }

  onAccept () {
    if (this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
    if (this.isWizard) {
      this.acceptPortfolioDuringWizard();
    } else {
      this.updatePortfolio();
    }
  }

  get createAction () {
    if (this.custodianSettingsStore.isHsaBankCustodian) {
      if (this.isCreatingAccount) {
        return this.drivewealthWizardStore.createCustomerAccount;
      }
      if (this.isPreenrollment) {
        return this.drivewealthWizardStore.preenrollCustomer;
      }
      if (this.isSavingAccountClaims) {
        return this.drivewealthWizardStore.claimAccount;
      }
    }

    return () => Promise.resolve();
  }

  get savePortfolioAction () {
    if (this.custodianSettingsStore.isHsaBankCustodian) {
      return this.createAction;
    }

    return this.investmentStrategyStore.storeQuestionnaire;
  }

  acceptPortfolioDuringWizard () {
    this.$emit("submitting", true);
    this.savePortfolioAction(this.accountId)
      .then(() => this.drivewealthWizardStore.setInvestmentStrategyPortfolioId(
        this.investmentStrategyStore.portfolioId))
      .then(() => {
        if (!this.isWizard) {
          this.notifierStore.setSuccess("Your investment portfolio selection has been saved.");
        } else {
          this.drivewealthWizardStore.setWizardStepComplete(DrivewealthWizardStep.PortfolioConfirmation);
        }
      })
      .then(() => {
        this.isSubmitting = false;
        this.$emit("submitting", false);
        this.$emit("portfolioSelected");
      })
      .catch(err => {
        this.notifierStore.setDanger(
          (err && err.errorMessage) || "Error processing your request. Please try again later");
        this.isSubmitting = false;
        this.$emit("submitting", false);
      });
  }

  updatePortfolio () {
    new Promise<void>((resolve, _) => resolve()).then(() => {
        if (!this.accountId) {
          this.investmentStrategyStore.storeQuestionnaire();
        }
      })
      .then(() => {
        if (this.accountId) {
          this.drivewealthStore.updateAccountV2({
            accountManagementType: null,
            investmentAccountManagementType: DrivewealthAccountManagementType.RiaManaged,
            portfolioId: this.investmentStrategyStore.portfolioId,
            accountId: this.accountId
          });
        } else {
          this.drivewealthStore.updateAccount({
            accountManagementType: null,
            investmentAccountManagementType: DrivewealthAccountManagementType.RiaManaged,
            portfolioId: this.investmentStrategyStore.portfolioId
          });
        }
      })
      .then(() => {
        if (this.accountId) {
          this.drivewealthStore.getAccountSummaryV2({ force: true, dwAccountId: this.accountId });
        }
      })
      .then(() => {
        this.notifierStore.setSuccess("Your investment portfolio change has been accepted.");
        this.investmentStrategyStore.resetQuestionnaire();
        this.$router.push({ name: RouteNames.InvestmentAccountInfo });
      })
      .catch(err => {
        this.notifierStore.setDanger((err && err.errorMessage) || "Error processing your request. Please try again later");
      })
      .finally(() => {
        this.isSubmitting = false;
      });
  }

  holdingFields = [
    {
      key: "instrument",
      label: "Investment",
      thClass: "text-left pl-2",
      tdClass: "pl-2"
    },
    {
      key: "fund_type",
      label: "Fund Type",
      thClass: "text-center",
      tdClass: "text-center"
    },
    {
      key: "allocation",
      label: "Target Allocation",
      thClass: "text-right",
      tdClass: "text-right"
    }
  ];

  get holdingItems () {
    if (!this.investmentStrategyStore.managedPortfolio) {
      return [];
    }
    return this.investmentStrategyStore.managedPortfolio.instruments.map(h => ({
      instrument: { symbol: h.stockSymbol, companyName: h.fundName, website: h.webSite, imageUrl: h.imageUrl },
      fund_type: this.drivewealthStore.fundTypeDisplayCopy(h.fundType),
      percentage: (h.target * 100).toFixed(2)
    }));
  }

  get portfolioChanged (): boolean {
    return this.investmentStrategyStore.portfolioId !== this.currentPortfolioId;
  }

  get riskPercentage (): number {
    if (this.custodianSettingsStore.isHsaBankCustodian) {
      const adjusted = ((this.investmentStrategyStore.managedPortfolio.score - 2.5) * 2);
      return adjusted / 100;
    }

    const max = 75;
    const min = 29;
    const formattedScore = this.investmentStrategyStore.managedPortfolio.score;
    const adjusted = formattedScore - min;
    return 1 - (adjusted / (max - min));
  }
}
